// extracted by mini-css-extract-plugin
module.exports = {"button":"AskAiButton_button__i0UL6","active":"AskAiButton_active__2RFST"};